import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 112.34 122.88"
    {...props}
  >
    <title>{'only-use-the-trolley'}</title>
    <path
      d="M53.85 94.05a14.42 14.42 0 1 1-14.41 14.42 14.43 14.43 0 0 1 14.41-14.42ZM3.92 9.83A5 5 0 1 1 6 .11L28.56 5 51.9 87.53a20.87 20.87 0 0 0-9.4 3.24L20.63 13.45 3.92 9.83Zm48.75 47L92 46.87a2.22 2.22 0 0 1 2.62 1.54l8.59 30a2 2 0 0 1-1.43 2.59l-39.32 9.9a2.22 2.22 0 0 1-2.62-1.54l-8.6-30a2 2 0 0 1 1.43-2.55ZM41 16 80.23 6a2.24 2.24 0 0 1 2.63 1.54l8.88 30a2 2 0 0 1-1.4 2.55l-39.23 9.97a2.24 2.24 0 0 1-2.63-1.54l-8.89-30A2 2 0 0 1 41 16Zm30.16 80.53 35-9.23a5 5 0 1 1 2.53 9.6l-33.92 9a20.93 20.93 0 0 0-3.56-9.33Zm-17.31 8.4a3.54 3.54 0 1 1-3.54 3.54 3.53 3.53 0 0 1 3.54-3.54Z"
      style={{
        fillRule: 'evenodd'
      }}
    />
  </svg>
)

export default SvgComponent
